import Organization from "@/classes/organization";
import Property from "@/classes/property";
import Station from "@/classes/station";

export default function mapKnownValues(cl: any, params: any, setterLookup: string[] = []) {
  for (const property in params) {
    if (setterLookup.includes(property)) {
      cl[property] = params[property];
      // eslint-disable-next-line no-prototype-builtins
    } else if (cl.hasOwnProperty(property)) {
      cl[property] = params[property];
    }
  }
}

export function fromDecompressedToOrganizations(decompressed) {
  return decompressed.map(
    organization =>
      new Organization({
        ...organization,
        properties: organization.properties.map(
          property =>
            new Property({
              ...property,
              stations: property.stations.map(station => new Station(station))
            })
        )
      })
  );
}
